export default "__VITE_ASSET__BbznwWLZ__$_?component__"